import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles, TableRow, TableCell, Tooltip } from '@material-ui/core'
import { CloudDownload as DownloadIcon } from '@material-ui/icons'
import moment from 'moment'

import ListAvatarAndCarBrand from '../common/subComponents/ListAvatarAndCarBrand'
import DropdownMenu from '../common/DropdownMenu'

import * as NOTIFICATION from '../../utils/notification'
import * as CONSTANTS from '../../utils/constants'
import * as STOCK from '../../redux/actions/stocks'
import { formatNumber, ClickWrapper } from '../../utils/helpers'
import config from '../../config/local.json'

const styles = theme => ({
    fieldText: {
        fontWeight: 'normal',
        fontSize: 14,
        paddingTop: 4
    },
    title: {
        width: 350
    },
    clickedButton: {
        color: 'green'
    },
    listWrapper: {
        '& span:not(:first-child)': {
            display: 'inline-block',
            marginLeft: '5px'
        }
    },
    hrefStyle: {
        color: 'black',
        paddingRight: 8
    },
    iconStyle: {
        fontSize: 24
    },
    expireStyle: {
        color: 'red',
        fontWeight: 500
    }
})

class TestDriveList extends Component {

    render() {
        const logoPath = `${config.baseUrl}/cars/brands/${this.props.item.stock.carBrandId}/image`
        let fieldsToRenderInPrimaryText = [
            { field: CONSTANTS.TEST_DRIVE_FIELDS.PROVIDER, name: this.props.language.stock.provider },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.CLIENT, name: this.props.language.stock.client },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.USER, name: this.props.language.stock.username },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.CONTRACT_NUMBER, name: this.props.language.offer.testDrive.contractNumber },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.CONTRACT_DATE, name: this.props.language.offer.testDrive.contractDate },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.END_DATE, name: this.props.language.offer.testDrive.endDate },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.PERIOD_DAYS, name: this.props.language.offer.testDrive.period },
            { field: CONSTANTS.TEST_DRIVE_FIELDS.KM_LIMIT, name: this.props.language.offer.testDrive.kmLimit }
        ]

        return (
            <Tooltip placement="top" title={this.props.item.stock.comment}>
                <TableRow>
                    <ClickWrapper onClick={() => { }}>
                        <TableCell>
                            <ListAvatarAndCarBrand
                                carBrandName={this.props.item.stock.carBrand.name}
                                carModelName={this.props.item.stock.carModel.name}
                                logoPath={logoPath}
                            />
                        </TableCell>
                        {fieldsToRenderInPrimaryText.map((fieldObj, index) => {
                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.PROVIDER) {
                                return (
                                    <TableCell key={index} >
                                        {this.props.item.stock[fieldObj.field] ? <span className={this.props.classes.fieldText}>{`${this.props.item.stock[fieldObj.field].name}`}</span> : null}
                                    </TableCell>
                                )
                            }
                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.CLIENT) {
                                return (
                                    <TableCell key={index} >
                                        {this.props.item.client[fieldObj.field] ? <span className={this.props.classes.fieldText}>{`${this.props.item.client[fieldObj.field]}`}</span> : <span className={this.props.classes.fieldText}>{this.props.item.client['contactName'] || '-'}</span>}
                                    </TableCell>
                                )
                            }
                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.USER) {
                                return (
                                    <TableCell key={index} >
                                        {this.props.item[fieldObj.field] ? <span className={this.props.classes.fieldText}>{`${this.props.item[fieldObj.field].fullName}`}</span> : null}
                                    </TableCell>
                                )
                            }
                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.CONTRACT_DATE) {
                                return (
                                    <TableCell size='small' key={index} >
                                        {this.props.item[fieldObj.field] ? <span className={this.props.classes.fieldText}>{`${moment(this.props.item[fieldObj.field]).format(CONSTANTS.DEFAULT_DATE_FORMAT)}`} </span> : <span className={this.props.classes.fieldText}>-</span>}
                                    </TableCell>
                                )
                            }

                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.END_DATE) {
                                let expiresInDay
                                // If extend rents then display last end date of array
                                if (this.props.item.extendTestDrives && this.props.item.extendTestDrives.length) {
                                    expiresInDay = moment(this.props.item.extendTestDrives[this.props.item.extendTestDrives.length - 1].to).diff(moment(), 'days')

                                    return (
                                        <TableCell size='small' key={index} >
                                            {this.props.item[fieldObj.field] ? <span className={`${this.props.classes.fieldText} ${expiresInDay <= CONSTANTS.END_DATE_EXPIRATION_DAYS ? this.props.classes.expireStyle : ''}`}>{`${moment(this.props.item.extendTestDrives[this.props.item.extendTestDrives.length - 1].to).format(CONSTANTS.DEFAULT_DATE_FORMAT)}`} </span> : <span className={this.props.classes.fieldText}>-</span>}
                                        </TableCell>
                                    )
                                }

                                expiresInDay = moment(this.props.item[fieldObj.field]).diff(moment(), 'days')
                                return (
                                    <TableCell size='small' key={index} >
                                        {this.props.item[fieldObj.field] ? <span className={`${this.props.classes.fieldText} ${expiresInDay <= CONSTANTS.END_DATE_EXPIRATION_DAYS ? this.props.classes.expireStyle : ''}`}>{`${moment(this.props.item[fieldObj.field]).format(CONSTANTS.DEFAULT_DATE_FORMAT)}`} </span> : <span className={this.props.classes.fieldText}>-</span>}
                                    </TableCell>
                                )

                            }

                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.PERIOD_DAYS && this.props.item.extendTestDrives && this.props.item.extendTestDrives.length) {
                                const periodDaysSum = this.props.item.extendTestDrives.map(item => item.days).reduce((sum, currValue) => sum + currValue)
                                return (
                                    <TableCell key={index} >
                                        {this.props.item[fieldObj.field] ?
                                            <span className={this.props.classes.fieldText}>
                                                {`${formatNumber(this.props.item[fieldObj.field] + periodDaysSum)} ${fieldObj.symbol ? fieldObj.symbol : ""}`} </span>
                                            : <span className={this.props.classes.fieldText}>{`0 ${fieldObj.symbol ? fieldObj.symbol : ""}`}</span>}
                                    </TableCell>
                                )
                            }

                            if (fieldObj.field === CONSTANTS.TEST_DRIVE_FIELDS.CONTRACT_NUMBER) {
                                return (
                                    <TableCell key={index} >
                                        {this.props.item[fieldObj.field] ?
                                            <span className={this.props.classes.fieldText}>
                                                {`${this.props.item[fieldObj.field]} ${fieldObj.symbol ? fieldObj.symbol : ""}`} </span>
                                            : <span className={this.props.classes.fieldText}>{`0 ${fieldObj.symbol ? fieldObj.symbol : ""}`}</span>}
                                    </TableCell>
                                )
                            }
                            return (
                                <TableCell key={index} >
                                    {this.props.item[fieldObj.field] ?
                                        <span className={this.props.classes.fieldText}>
                                            {`${formatNumber(this.props.item[fieldObj.field])} ${fieldObj.symbol ? fieldObj.symbol : ""}`} </span>
                                        : <span className={this.props.classes.fieldText}>{`0 ${fieldObj.symbol ? fieldObj.symbol : ""}`}</span>}
                                </TableCell>
                            )
                        })}
                    </ClickWrapper>
                    {this.props.actions ? <TableCell>
                        <DropdownMenu type={this.props.language.stock.actions} item={this.props.item} items={[
                            {
                                tooltip: this.props.language.stock.getContract,
                                onClick: (_, row) => window.open(`${CONSTANTS.BACKEND_URL}testDrives/${this.props.item.id}/contract`, "_blank"),
                                withoutBorder: true
                            },
                            {
                                tooltip: this.props.language.stock.sendContract,
                                onClick: (_, row) => {
                                    if (window.confirm(this.props.language.testDriveConfirmations.send)) {
                                        this.props.sendTestDriveContract(this.props.item.id).then(() => {
                                            NOTIFICATION.success(this.props.language.stock.mailSent)
                                        })
                                            .catch(() => NOTIFICATION.error(this.props.language.stock.mailFail))
                                    }
                                }
                            },
                            {
                                tooltip: this.props.language.stock.extension,
                                onClick: (_, row) => this.props.setTestDriveExtendModal(row),
                                withoutBorder: true
                            },
                            {
                                tooltip: this.props.language.stock.downloadExtension,
                                onClick: (_, row) => {
                                    let lastExtend
                                    if (row.extendTestDrives && row.extendTestDrives.length) {
                                        lastExtend = row.extendTestDrives[row.extendTestDrives.length - 1]
                                    }
                                    window.open(`${CONSTANTS.BACKEND_URL}testDrives/${row.id}/extendContract?from=${lastExtend ? lastExtend.from : null}&to=${lastExtend ? lastExtend.to : null}`, "_blank")
                                },
                                withoutBorder: true

                            },
                            {
                                tooltip: this.props.language.stock.sendExtendContract,
                                onClick: (_, row) => {
                                    if (window.confirm(this.props.language.testDriveConfirmations.sendExtend)) {
                                        this.props.sendExtendTestDriveContract(this.props.item.id).then(() => {
                                            NOTIFICATION.success(this.props.language.stock.mailSent)
                                        })
                                            .catch(() => NOTIFICATION.error(this.props.language.stock.mailFail))
                                    }
                                }
                            },
                            {
                                tooltip: this.props.language.stock.cancel,
                                onClick: (_, row) => {
                                    window.open(`${CONSTANTS.BACKEND_URL}testDrives/${this.props.item.id}/endContract`, "_blank")
                                },
                                withoutBorder: true
                            },
                            {
                                tooltip: this.props.language.stock.sendCloseContract,
                                onClick: (_, row) => {
                                    if (window.confirm(this.props.language.testDriveConfirmations.sendClose)) {
                                        this.props.sendCancelTestDriveContract(this.props.item.id).then(() => {
                                            NOTIFICATION.success(this.props.language.stock.mailSent)
                                        })
                                            .catch(() => NOTIFICATION.error(this.props.language.stock.mailFail))
                                    }
                                },
                                withoutBorder: true
                            },
                            {
                                tooltip: this.props.language.stock.closeRent,
                                onClick: (_, row) => {
                                    if (window.confirm(this.props.language.testDriveConfirmations.close)) {
                                        this.props.closeTestDrive(this.props.item.id).then(() => {
                                            this.props.getTestDrives()
                                        })
                                    }
                                }
                            }
                        ]} />
                    </TableCell> : null}
                </TableRow >
            </Tooltip>
        )
    }
}

const mapStateToProps = state => ({
    language: state.languageReducer.i18n.itemDetails
})

const mapDispatchToProps = dispatch => ({
    sendTestDriveContract: testDriveId => dispatch(STOCK.sendTestDriveContract(testDriveId)),
    getExtendTestDriveContract: (testDriveId, from, to) => dispatch(STOCK.getTestDriveExtend(testDriveId, from, to)),
    sendExtendTestDriveContract: testDriveId => dispatch(STOCK.sendExtendTestDriveContract(testDriveId)),
    sendCancelTestDriveContract: testDriveId => dispatch(STOCK.sendCancelTestDriveContract(testDriveId)),
    closeTestDrive: testDriveId => dispatch(STOCK.closeTestDrive(testDriveId))
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(TestDriveList))